import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

import {
    DisplayMode,
    GridAlternatives,
    GridCategory,
    GridCategoryMetas,
    GridEdito,
    GridFacet,
    GridFilter,
    GridFilterGroup,
    GridMenuLevel,
    GridProduct,
    GridSortByOption,
    PageType,
    GridType,
    PriceRange,
    Facet,
} from "../model/grid.model";

export const sendPageViewEvent = createAction(
    "[Grid] Send Page View Event",
    props<{
        previousPageHasChanged: boolean;
    }>(),
);

export const fetchGridDatasSuccess = createAction(
    "[Grid] Fetch Products Success",
    props<{
        total: number;
        url: string;
        redirectionUrl: string;
        alternatives: GridAlternatives;
        products: GridProduct[];
        filterGroups?: GridFilterGroup[];
        editos: GridEdito[];
        facet?: GridFacet;
        isFirstPage?: boolean;
        isFromPreviousGrid?: boolean;
        isHeroProduct: boolean;
    }>(),
);

export const scrollToPreviousProduct = createAction(
    "[Grid] Scroll to previous product when back To Grid",
);

export const fetchGridDatasFailure = createAction(
    "[Grid] Fetch Products Failure",
    props<{ error: Error | HttpErrorResponse }>(),
);

export const loadMoreProducts = createAction("[Grid] Load More Products");

export const loadMoreProductsSuccess = createAction(
    "[Grid] Load More Products Success",
    props<{ total: number; products: GridProduct[] }>(),
);

export const changeDisplayMode = createAction(
    "[Grid] Change display mode",
    props<{ displayMode: DisplayMode }>(),
);

export const initGridCategory = createAction(
    "[Grid] Init grid category",
    props<{ category: GridCategory; menuLevel: GridMenuLevel }>(),
);

export const fetchCategoryMetas = createAction(
    "[Grid] Fetch category metas",
    props<{ categoryPimCode: string }>(),
);

export const fetchCategoryMetasSuccess = createAction(
    "[Grid] Fetch category metas Success",
    props<{ categoryMetas: GridCategoryMetas }>(),
);

export const fetchCategoryMetasFailure = createAction(
    "[Grid] Fetch category metas Failure",
    props<{ error: Error | HttpErrorResponse; categoryPimCode: string }>(),
);

export const initGridPage = createAction(
    "[Grid] Init grid page",
    props<{
        displayMode?: DisplayMode;
        searchTerm?: string;
        pimCode?: string;
        fhParams?: string;
        sort?: string;
        facet?: Facet;
        gridType: GridType;
        pageNumber: number;
        isDisplayOnly?: boolean;
    }>(),
);

/**
 * launch when click on a filter
 */
export const updateGridFilter = createAction(
    "[Grid] Update Grid Filter",
    props<{
        filter: GridFilter;
        filterGroup: GridFilterGroup;
        isHighlightFilter: boolean;
    }>(),
);

/**
 * launch when seo links enabled
 */
export const updateSeoPaginationHeadLinks = createAction(
    "[Grid] Update SEO Pagination Head Links",
    props<{
        isSeoPaginationEnabled: boolean;
        totalProductsCount: number;
        pageNumber: number;
    }>(),
);

/**
 * launch when move the price slider
 */
export const updateGridFilterPrice = createAction(
    "[Grid] Update Filter Price",
    props<{ prices: PriceRange }>(),
);

export const updateMissingFacet = createAction(
    "[Grid] Update Missing Facet",
    props<{ missingFacet: boolean }>(),
);

export const updateGridSort = createAction(
    "[Grid] Update Grid sort",
    props<{
        sortBy: GridSortByOption;
    }>(),
);

export const closeDialog = createAction(
    "[Grid] Close dialog",
    props<{
        gridUpdated: boolean;
    }>(),
);

export const clearMenuLevel = createAction("[Grid] Clear menu level");

export const openDialog = createAction("[Grid] Open dialog");

export const clearFilters = createAction("[Grid] Clear filters");

export const clearPriceFilter = createAction("[Grid] Clear price filter");

export const clearSortBy = createAction("[Grid] Clear sort by");

export const updateUrl = createAction("[Grid] Update url");

export const selectGridItem = createAction(
    "[Grid] Select result item",
    props<{
        product: GridProduct;
        index: number;
        fromQuickbuy: boolean;
    }>(),
);

/**
 * Used for faster back to grid
 */
export const setPositionInPage = createAction(
    "[Grid] Set product position in grid page",
    props<{ position: number }>(),
);

export const setIsFromPreviousGrid = createAction(
    "[Grid] Set flag back to grid",
    props<{ isFromPreviousGrid: boolean }>(),
);

/**
 * Used to differenciate grid -> grid from page -> grid navigation
 */
export const changePreviousPage = createAction(
    "[Grid] Update previous page",
    props<{ previousPage: PageType }>(),
);

/**
 * Used to differenciate grid -> grid from page -> grid navigation
 */
export const reinitializePagesLoaded = createAction(
    "[Grid] Reinitialized pages loaded",
);

export const navigateToGridPage = createAction("[Grid] Navigate to grid page");
